// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import {
  getDimensionLevelConfigArrayFromMetricRow,
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited,
  getIfGivenRowIsANewlyAddedRow,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { toastError } from '@presentational/notifications/utils';
import { ResetFormButton } from '@presentational/buttons/ResetFormButton';
import { useDeleteCommittedCapacityMetricLineItemMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';

const getIfCurrentDimensionRowIsTheLoneChildOfParentMetric = (metricRow) => {
  return getDimensionLevelConfigArrayFromMetricRow(metricRow).length === 1;
};

export const CommittedCapacityDimensionsLineItemDeleteContainer = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  dimensionIndex,
  metricIndex,
  dimensionArrayHelpers,
  metricArrayHelpers,
  reloadPageAfterDelete,
}) => {
  const { orgId, commitId } = useParams();
  const commitData = useContext(SPUserCommitDetailsContext);
  const [deleteFunc] = useDeleteCommittedCapacityMetricLineItemMutation();

  // Delete should always be enabled - only case when it will be disabled is if any other row is being edited
  const shouldDeleteButtonBeDisabled = getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited(
    configuredMetrics,
    dimensionRow
  );

  return (
    <ResetFormButton
      disabled={shouldDeleteButtonBeDisabled}
      onClick={async () => {
        if (getIfGivenRowIsANewlyAddedRow(dimensionRow)) {
          // If it is a newly added row, then simply delete it from UI
          // Besides that, if it was the only item added for a new metric, then, deleting this one should delete the parent metric too
          dimensionArrayHelpers.remove(dimensionIndex);
          if (getIfCurrentDimensionRowIsTheLoneChildOfParentMetric(metricRow)) {
            metricArrayHelpers.remove(metricIndex);
          }
          return;
        }
        const payload = {
          commit_version: commitData?.version,
        };
        const { error } = await deleteFunc({
          orgId,
          commitId,
          payload,
          committedCapacityId: dimensionRow[COMMITTED_CAPACITY.ID_BACKEND_FIELD_NAME],
        });

        if (error) {
          toastError(
            error,
            'There was an error in deleting the config, please contact #cloud-commitment-estimator channel!'
          );
        } else {
          if (reloadPageAfterDelete) {
            window.location.reload();
          } else {
            dimensionArrayHelpers.remove(dimensionIndex);
          }
        }
      }}
    />
  );
};
